export default {
  // 登录
  login: '/uc/login/account',
  userInfo: '/uc/identify/user/baseinfo',
}
